import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ExamHunanInfo = _resolveComponent("ExamHunanInfo");
  var _component_ExamInfoFinal = _resolveComponent("ExamInfoFinal");
  var _component_a_spin = _resolveComponent("a-spin");
  var _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createBlock(_component_a_modal, {
    width: "800px",
    visible: _ctx.data.visible,
    "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.data.visible = $event;
    }),
    title: _ctx.isNocFlag ? '比赛须知' : '活动须知',
    "cancel-text": "暂不答题",
    "ok-text": _ctx.OkText,
    "mask-closable": false,
    onOk: _ctx.onStartExamButtonClick
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_a_spin, {
        size: "large",
        tip: "正在加载数据中...",
        spinning: _ctx.loading,
        delay: 200
      }, {
        default: _withCtx(function () {
          return [_ctx.isLimitHuNanAct ? (_openBlock(), _createBlock(_component_ExamHunanInfo, {
            key: 0,
            data: _ctx.data
          }, null, 8, ["data"])) : (_openBlock(), _createBlock(_component_ExamInfoFinal, {
            key: 1,
            data: _ctx.data
          }, null, 8, ["data"]))];
        }),
        _: 1
      }, 8, ["spinning"])];
    }),
    _: 1
  }, 8, ["visible", "title", "ok-text", "onOk"]);
}